import { useFormikContext } from "formik";
import React, { useMemo } from "react";
import { Permission, ProductObject, SelectionState, Seller } from "types";
import { useVisibility } from "../../../hooks/useVisibility";
import { getSelectedExperiences, getSelectionState } from "../../../models/SelectionState";
import { IsGranted } from "../../Common/IsGranted";
import { ProductSelectorModal } from "../../Common/ProductSelectorModal";
import { SelectedProductListInput } from "../../Common/SelectedProductListInput";

export const AutoAcceptPreferences = () => {
    const [isOpen, { toggle }] = useVisibility(false);
    const { values, setFieldValue } = useFormikContext<Seller>();

    const selectedProducts = useMemo(() => {
        return getSelectionState(values.autoAccept);
    }, [values.autoAccept]);

    const handleConfirm = (autoAccept: SelectionState) => {
        setFieldValue("autoAccept", getSelectedExperiences(autoAccept));
    };

    return (
        <IsGranted permissions={Permission.PREFERENCES_SELLER_VIEW}>
            <div className="mb-4">
                <h3 className="mb-4">Experiences</h3>

                <SelectedProductListInput
                    label="Auto Accept"
                    selectedProducts={selectedProducts}
                    onEditClick={toggle}
                />

                <ProductSelectorModal
                    allowEmptySelection
                    isOpen={isOpen}
                    value={selectedProducts}
                    objects={[ProductObject.EXPERIENCE, ProductObject.PACKAGE]}
                    onClose={toggle}
                    onConfirm={handleConfirm}
                />
            </div>
        </IsGranted>
    );
};
